import * as React from "react";
import * as Scrivito from "scrivito";
import { Container } from "reactstrap";
import { ObjValidator } from "components";
import { Form, Formik } from "formik";
import {
  ConfiguratorSupportHeader,
  ConfiguratorSupportBody,
  SupportInquirySchema,
  SUPPORT_INQUIRY_INITIAL_VALUES,
} from "components/ConfiguratorSupport";
import { useAuthStore } from "stores/authStore";
import { validateWithZod } from "utils";

const ConfiguratorSupport = Scrivito.connect(() => {
  const initialValues = {
    ...SUPPORT_INQUIRY_INITIAL_VALUES,
    email: useAuthStore.use.currentUser()
      ? useAuthStore.use.currentUser().email
      : "",
  };

  return (
    <div className="pt-6 bg-gray-100 h-100">
      <Container className="pb-8">
        <Formik
          initialValues={initialValues}
          validationSchema={validateWithZod(SupportInquirySchema)}
          validateOnChange={false}
          validateOnBlur={false}
        >
          <Form>
            <ConfiguratorSupportHeader />
            <ConfiguratorSupportBody />
          </Form>
        </Formik>
      </Container>
    </div>
  );
});

const CheckedPage = (props) => (
  <ObjValidator {...props}>
    <ConfiguratorSupport {...props} />
  </ObjValidator>
);

export default CheckedPage;
Scrivito.provideComponent("ConfiguratorSupport", CheckedPage);
